import React, { useState } from 'react'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Popover from '@material-ui/core/Popover'
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import DeleteOutlinedIcon from 'components/material-symbol/icons/Delete'
import { makeStyles } from '@material-ui/core/styles'
import DeleteBookingTypeDialog from './delete-booking-type-dialog'

const useStyles = makeStyles(theme => ({
  menuItemIcon: {
    color: theme.palette.text.primary,
    minWidth: theme.spacing(5),
  },
}))

const BookingTypeActionMenu = ({
  bookingType,
  isOpen,
  handleClose,
  anchorEl,
  onDeleted,
}) => {
  const classes = useStyles()
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false)

  const openDeleteDialog = () => {
    setIsDeleteDialogOpen(true)
  }

  const closeDeleteDialog = () => {
    setIsDeleteDialogOpen(false)
  }

  return (
    <>
      <Popover
        open={isOpen}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuList autoFocusItem onClick={handleClose}>
          <MenuItem
            onClick={openDeleteDialog}
            data-cy={`${bookingType.title} delete`}
          >
            <ListItemIcon className={classes.menuItemIcon}>
              <DeleteOutlinedIcon fontSize="small" />
            </ListItemIcon>
            Delete
          </MenuItem>
        </MenuList>
      </Popover>
      {isDeleteDialogOpen ? (
        <DeleteBookingTypeDialog
          bookingTypeId={bookingType.id}
          isOpen={isDeleteDialogOpen}
          onClose={closeDeleteDialog}
          onDeleted={onDeleted}
        />
      ) : null}
    </>
  )
}

export default BookingTypeActionMenu
